export const countries = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antigua & Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bonaire",
    "Bosnia & Herzegovina",
    "Botswana",
    "Brazil",
    "British Indian Ocean Ter",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Canary Islands",
    "Cape Verde",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Channel Islands",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos Island",
    "Colombia",
    "Comoros",
    "Congo",
    "Cook Islands",
    "Costa Rica",
    "Cote DIvoire",
    "Croatia",
    "Cuba",
    "Curacao",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "East Timor",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Falkland Islands",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Ter",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Great Britain",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guinea",
    "Guyana",
    "Haiti",
    "Hawaii",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "Indonesia",
    "India",
    "Iran",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea North",
    "Korea South",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macau",
    "Macedonia",
    "Madagascar",
    "Malaysia",
    "Malawi",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Midway Islands",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Nambia",
    "Nauru",
    "Nepal",
    "Netherland Antilles",
    "Netherlands (Holland, Europe)",
    "Nevis",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau Island",
    "Palestine",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn Island",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Republic of Montenegro",
    "Republic of Serbia",
    "Reunion",
    "Romania",
    "Russia",
    "Rwanda",
    "St Barthelemy",
    "St Eustatius",
    "St Helena",
    "St Kitts-Nevis",
    "St Lucia",
    "St Maarten",
    "St Pierre & Miquelon",
    "St Vincent & Grenadines",
    "Saipan",
    "Samoa",
    "Samoa American",
    "San Marino",
    "Sao Tome & Principe",
    "Saudi Arabia",
    "Senegal",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syria",
    "Tahiti",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad & Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks & Caicos Is",
    "Tuvalu",
    "Uganda",
    "United Kingdom",
    "Ukraine",
    "United Arab Emirates",
    "United States of America",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City State",
    "Venezuela",
    "Vietnam",
    "Virgin Islands (Brit)",
    "Virgin Islands (USA)",
    "Wake Island",
    "Wallis & Futana Is",
    "Yemen",
    "Zaire",
    "Zambia",
    "Zimbabwe"
];

export const organisationType = [
    "Residential",
    "Commercial"
];

export const numberOfEmployees = [
    "1-4",
    "5-9",
    "10-24",
    "25-49",
    "50-99",
    "100-249",
    "250-499",
    "500-999",
    "1000-4999",
    "5000+"
];

export const financialTurnover = (currency) => [
    `N/A (for nonprofit organisations)`,
    `${currency}1K - ${currency}250K`,
    `${currency}250K - ${currency}500K`,
    `${currency}500K - ${currency}1M`,
    `${currency}1M - ${currency}5M`,
    `${currency}5M - ${currency}10M`,
    `${currency}10M - ${currency}50M`,
    `${currency}50M - ${currency}100M`,
    `${currency}100M - ${currency}500M`,
    `${currency}500M - ${currency}1BN`,
    `${currency}>1BN`
];

export const industries = [
    "Advertising/Media/Publishing",
    "Aerospace & Aviation",
    "Agriculture & Forestry",
    "Automotive",
    "Banking/Accounting/Financial",
    "Design & Build",
    "Education & Training",
    "Energy & Utilities",
    "Entertainment/Travel/Hospitality",
    "Environmental & CleanTech Products and Services",
    "Events",
    "Food & Beverage",
    "Government & Public Administration",
    "Healthcare",
    "Insurance",
    "Legal Solutions",
    "Life Sciences",
    "Manufacturing",
    "Marine & Natural Resources",
    "Marketing & Communications",
    "Medical Devices",
    "Non profit Organisations",
    "Pharmaceutical",
    "Property & Facilities",
    "Real Estate",
    "Retail & Wholesale",
    "Technology",
    "Telecommunications",
    "Transportation/Logistics/Shipping",
    "Other (please specify below)"
];

export const detailFields = [
    "category_id",
    "name",
    "first_name",
    "last_name",
    "job_position",
    "organization_name",
    "organization_address_line_1",
    "organization_address_line_2",
    "organization_country",
    "organization_city",
    "organization_province",
    "organization_zip",
    "organization_address_type",
    "organization_email",
    "organization_phone",
    "entry_summary",
    "number_of_employees",
    "financial_turnover",
    "industry",
    "other_industry",
    "sub_market",
    "supplier_1",
    "supplier_2",
    "supplier_3",
    "supplier_4",
    "website_url",
    "twitter_url",
    "linkedin_url",
    "facebook_url"
];

export const projectAreaSizes = [
    "1,000 - 10,000 sq. ft.",
    "10,001 - 50,000 sq. ft.",
    "50,001 - 100,000 sq. ft.",
    "100,001 - 150,000 sq. ft.",
    "Over 150,000 sq. ft."
];

export const projectValues = (currency) => [
    `Under ${currency}500K`,
    `${currency}501K - ${currency}1M`,
    `${currency}1M - ${currency}2.5M`,
    `${currency}2.5M - ${currency}5M`,
    `${currency}5M - ${currency}7.5M`,
    `${currency}7.5M - ${currency}10M`,
    `Over ${currency}10M`
];
